export default function isTouchDevice() {
  return typeof document !== 'undefined' && 'ontouchstart' in document?.documentElement;
}
